import { Component } from '@angular/core';

@Component({
    selector: 'app-terminos-condiciones',
    templateUrl: './terms.component.html'
})

export class TermsComponent {}